import React, { useContext } from "react";
import { Modal } from "@mui/material";

export const BaseModal = ({ onClose, children, height, width, ...props }) => {
  const handleBackdropClick = (e) => {
    if (e.target.className === "modal-wrapper") {
      onClose();
    }
  };

  return (
    <Modal {...props}>
      <div className="modal-wrapper" onClick={handleBackdropClick}>
        <div className="modal-container" style={{ height, width }}>
          {children}
        </div>
      </div>
    </Modal>
  );
};
